import BookFreeClassBtn from '@components/common/book-free-class-btn'

type Props = {
  urlQuery?: string
}

const SeePersonalizedLessons = ({ urlQuery }: Props) => {
  return (
    <section
      className="bg-white py-12 lg:py-16 px-5"
      style={{
        background: `url('/images/courses/math/bg-image.png') repeat-x`,
      }}
    >
      <div className="container mx-auto text-center">
        <h2 className="text-2xl lg:text-4xl font-600 leading-tight mb-4 text-grey max-w-4xl mx-auto">
          See how personalized lessons help your child grow in Math
        </h2>
        <p className="text-base lg:text-lg text-grey max-w-4xl mx-auto mb-10">
          Most Math struggles begin with a concept that doesn&apos;t click. Over
          time, those small gaps can turn into frustration and lost confidence.
          Our personalized Math lessons are designed around your child&apos;s
          learning pace, helping them build strong understanding, close learning
          gaps early, and develop clarity and confidence in Math.
        </p>
        <div className="flex-1 w-full max-w-2xl mx-auto flex-shrink-0 mt-3">
          <iframe
            src="https://iframe.mediadelivery.net/embed/239253/ff66014b-b338-4d8c-8c23-7a2f8faf1eb8?autoplay=false&loop=true&muted=false&preload=false&responsive=true"
            className="w-full h-96 border-none bg-black"
            allow="accelerometer;gyroscope;encrypted-media;picture-in-picture;"
            allowFullScreen
          />
        </div>
        <div className="flex justify-center mt-10">
          <BookFreeClassBtn query={urlQuery} />
        </div>
      </div>
    </section>
  )
}

export default SeePersonalizedLessons
